import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { INewProfileInputDto, IProfileDto } from "../types/Types";
import { PaginatorDto } from "../pages/eigeneauftraege/EigeneAuftraegeListe";

/**
 * @author mb
 */
export const AdminProfileAPI = createApi({
    reducerPath: "adminProfileAPI",
    baseQuery: fetchBaseQuery(
        {
            baseUrl: process.env.REACT_APP_API_URL! + process.env.REACT_APP_API_VERSION! + "adminprofile",
            credentials: 'include'
        }),
    tagTypes: ['adminProfileAPI'], // for caching
    endpoints: (builder) => ({
        getProfiles: builder.mutation<PaginatorDto, { offset: number, limit: number, search: string, sortBy: string, sortDirection: string }>(
            {
                query: (dto) => ({
                    url: '',
                    method: 'post',
                    credentials: 'include',
                    body: dto
                })
            }
        ),
        getProfile: builder.mutation<IProfileDto, string>(
            {
                query: (uid) => ({
                    url: `` + uid,
                    method: 'get',
                    credentials: 'include',
                })
            }
        ),
        deleteProfile: builder.mutation<void, string>(
            {
                query: (uid) => ({
                    url: `` + uid,
                    method: 'delete',
                    credentials: 'include',
                })
            }
        ),
        createOrUpdateProfileService: builder.mutation<void, INewProfileInputDto>(
            {
                query: (dto) => ({
                    url: `createOrUpdate`,
                    method: 'put',
                    credentials: 'include',
                    body: dto
                })
            }
        ),
       
       
    })
});

export const {
    
    useGetProfilesMutation,
    useGetProfileMutation,
    useDeleteProfileMutation,
    useCreateOrUpdateProfileServiceMutation,
    
} = AdminProfileAPI;
